module.exports = __webpack_public_path__ + "img/list-item-row-right.edbb068b.svg";